"use strict";

/*
 * Textyle.js - v2.0
 * https://github.com/mycreatesite/Textyle.js
 * MIT licensed
 * Copyright (C) 2019 ma-ya's CREATE
 * https://myscreate.com
 */
(function ($) {
  $.fn.textyle = function (options) {
    var target = this;
    var targetTxt = target.contents();
    var defaults = {
      duration: 400,
      delay: 100,
      easing: 'swing',
      callback: null
    };
    var setting = $.extend(defaults, options);
    targetTxt.each(function () {
      var texts = $(this);
      if (this.nodeType === 3) {
        mkspn(texts);
      }
    });
    function mkspn(texts) {
      texts.replaceWith(texts.text().replace(/(\S)/g, '<span>$1</span>'));
    }
    return this.each(function () {
      var len = target.children().length;
      target.css('opacity', 1);
      for (var i = 0; i < len; i++) {
        target.children('span:eq(' + i + ')').delay(setting.delay * i).animate({
          opacity: 1,
          top: 0,
          left: 0
        }, setting.duration, setting.easing, setting.callback);
      }
      ;
    });
  };
})(jQuery);
jQuery(document).ready(function ($) {
  // https://www.jqueryscript.net/animation/text-reveal-effect-textyle.html
  // Text animation for banner h1 is now triggered by parallax.js when image fades in
  // Only trigger for non-banner text animations
  setTimeout(function () {
    $('.text_animation').not('.entry-header__header').each(function () {
      var $el = $(this);
      // Only trigger if not already animated (banner h1 will be animated by parallax.js)
      if (!$el.data('textyle-animated')) {
        $el.data('textyle-animated', true);
        $el.textyle({
          duration: 150,
          delay: 30,
          easing: 'swing'
        });
      }
    });
  }, 700);
});